/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Stack, Typography } from '@mui/material';

const PeriodoEmptyHint = ({
  ctaLabel,
  onApplySuggested,
  suggestedLabel,
}) => (
  <Alert
    severity="info"
    variant="outlined"
    sx={{ alignItems: 'center' }}
    action={(
      <Button color="inherit" size="small" onClick={onApplySuggested} sx={{ fontWeight: 600 }}>
        {ctaLabel}
      </Button>
    )}
  >
    <Stack spacing={0.25}>
      <Typography variant="body2" fontWeight={600}>
        Sem pesagens nesta semana
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {suggestedLabel
          ? `A semana filtrada está vazia. Sugestão: ${suggestedLabel}.`
          : 'A semana filtrada está vazia. Escolha outra semana nos chips ou no filtro.'}
      </Typography>
    </Stack>
  </Alert>
);

PeriodoEmptyHint.propTypes = {
  ctaLabel: PropTypes.string.isRequired,
  onApplySuggested: PropTypes.func.isRequired,
  suggestedLabel: PropTypes.string,
};

PeriodoEmptyHint.defaultProps = {
  suggestedLabel: '',
};

export default PeriodoEmptyHint;
